module.exports = __webpack_public_path__ + "img/12.b4a05fd5.svg";